import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@screener/uikit/components/dialog";
import { INVITES_MENU_LABEL, InvitesPanel } from "./invites-panel";
import { useInvites } from "./use-invites";

export interface InvitesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSessionInvalid: () => void;
}

/**
 * Окно приглашений (§104 п. 6): `Dialog` UIKit с панелью выдачи и отзыва.
 * Смонтировано всегда, но читает список только открытым; закрытие сбрасывает
 * состояние, включая выданный токен.
 */
export function InvitesDialog({ open, onOpenChange, onSessionInvalid }: InvitesDialogProps) {
  const invites = useInvites({ open, onSessionInvalid });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] overflow-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{INVITES_MENU_LABEL}</DialogTitle>
          <DialogDescription>
            Ссылка показывается один раз, сразу после создания: потом её не восстановить.
          </DialogDescription>
        </DialogHeader>
        <InvitesPanel
          state={invites.state}
          createdLink={invites.createdLink}
          creating={invites.creating}
          pendingIds={invites.pendingIds}
          failure={invites.failure}
          onCreate={() => void invites.create()}
          onRevoke={(id) => void invites.revoke(id)}
          onReload={() => void invites.reload()}
        />
      </DialogContent>
    </Dialog>
  );
}
